import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	BrowserWindow,
	IPropsStore,
	ISamePageUrlChangeListener,
	IStructureAPI,
	ITpaPopup } from '@wix/thunderbolt-symbols'
import {
	BrowserWindowSymbol,
	CurrentRouteInfoSymbol,
	pageIdSym,
	Props,
	StructureAPI,
	TpaPopupSymbol
} from '@wix/thunderbolt-symbols'
import type { ICurrentRouteInfo } from 'feature-router'
import type { ITpa, ITPAEventsListenerManager } from './types'
import { TpaEventsListenerManagerSymbol, TpaSymbol } from './symbols'

export const TpaCurrentCurrencyManager = withDependencies(
	[
		Props,
		StructureAPI,
		TpaEventsListenerManagerSymbol,
		CurrentRouteInfoSymbol,
		BrowserWindowSymbol,
		pageIdSym,
		TpaPopupSymbol,
		TpaSymbol,
	],
	(
		props: IPropsStore,
		structureAPI: IStructureAPI,
		tpaEventsListenerManager: ITPAEventsListenerManager,
		currentRouteInfo: ICurrentRouteInfo,
		browserWindow: BrowserWindow,
		pageId: string,
		{ getOpenedPopups }: ITpaPopup,
		{ rebuildTpasSrc }: ITpa
	): ISamePageUrlChangeListener => {
		const state: { previousCurrency: string | null } = { previousCurrency: null }

		return {
			onUrlChange(url) {
				const routerInfo = currentRouteInfo.getCurrentRouteInfo()
				if (!routerInfo) {
					return
				}

				const currency = url.searchParams.get('currency')
				if (currency === state.previousCurrency) {
					return
				}

				// Refresh static TPAs
				rebuildTpasSrc()

				// Refresh runtime TPAs
				Object.values(getOpenedPopups()).forEach((tpaCompData) => tpaCompData.refreshPopUp())

				state.previousCurrency = currency
			},
		}
	}
)
